import React from 'react';
import { SecurePdfViewer } from './SecurePdfViewer';

/**
 * SecurePdfViewDownload
 *
 * Renders a secured PDF entry: the document title link (styled per the CMS
 * anchor's own classes), which opens the PDF through the authenticated
 * `securepdf` endpoint, so admin PDFs stay protected.
 *
 * The separate View / Download buttons are intentionally hidden (commented
 * out below) - the title link is the only control.
 *
 * @param {Object} props
 * @param {string} props.href - PDF URL
 * @param {string} props.children - Link text
 * @param {string} props.className - CSS classes from the CMS anchor
 * @param {string} props.pageUrl - Current page URL
 * @param {Object} rest - Other props
 */
export function SecurePdfViewDownload({ href, children, className = '', pageUrl = null, ...rest }) {
  const isPdfLink = href && href.toLowerCase().endsWith('.pdf');

  if (!isPdfLink) {
    return (
      <a href={href} className={className} {...rest}>
        {children}
      </a>
    );
  }

  return (
    <span className="secure-pdf-controls" style={{ display: 'inline-flex', alignItems: 'center', gap: '10px' }}>
      {/* Title - clickable to view; styled per the CMS "Button" choice */}
      <SecurePdfViewer
        href={href}
        pageUrl={pageUrl}
        className={className}
        {...rest}
      >
        {children}
      </SecurePdfViewer>

      {/* View button - hidden
      <SecurePdfViewer
        href={href}
        pageUrl={pageUrl}
        className="button pdf-view-btn"
        {...rest}
      >
        View
      </SecurePdfViewer>
      */}

      {/* Download button - hidden
      <SecurePdfDownload
        href={href}
        pageUrl={pageUrl}
        className="button pdf-download-btn"
        {...rest}
      >
        Download
      </SecurePdfDownload>
      */}
    </span>
  );
}
